<script>
 import OneAudio from "./OneAudio.svelte";
  let items = window.items || [];
  let audiofiles = [];
 
  let lastvalid;
  let firstvalid;
  let cartid = window.cartid;
  let sku = window.sku;
  let loopcount = 0;
  let afcount = 0;

  $: {
    if (audiofiles && audiofiles.length) {
      lastvalid = audiofiles[audiofiles.length - 1].url.length;
      firstvalid = audiofiles[0].url.length;
      //   console.log(`lastvalid ${lastvalid} firstvalid ${firstvalid}`);
    }
  }
 function handleAddMore() {
     
    audiofiles = audiofiles.concat({
      title: "",
      notes: "",
      speaker: "",
      tags: [],
      url: "",
      sku: "",
      daq: false,
      verbatim: false,
      itemid: "",
      cutaudio: false,
      cuts: { start: "", end: "" },
      timestamps: false,
      count: afcount
    });
     afcount++;
    //console.log("handleaddmore", audiofiles);
  }

 if (items.length){
     items.forEach( item => {
         audiofiles.push(item);
     });
 }  else{
     handleAddMore();
 }

// console.log("items .length", items.length, items[items.length]);
</script>

<style>
 .btn.btn-secondary:hover {
     color: #cfcfcf;
 }
 .btn-default:disabled {
     color: #333;
 }
 input[type="button"]:disabled.btn-secondary,
 input[type="button"]:disabled.btn-secondary:hover,
 input[disabled].btn-secondary,
 input[disabled].btn-secondary:hover {
     color: #cfcfcf;
 }

 form {
     margin: auto;
     max-width: 98vw;
     text-align: left;
 }
 .replicator {
     margin-top: 1em;
     float: right;
 }
 .button-group {
     margin-bottom: 10px;
 }

 
 @media (max-width: 600px) {
     .replicator .btn {
         margin: 5px 0px;
         display: block;
         width:100%;
     }
 }

</style>

<form action="/store/add_or_update_item" method="POST" id="add_form" enctype="multipart/form-data">
    {#each audiofiles as af, i}
    <input type="hidden" name="submittedcount_{i}" value="{loopcount = i}"/>
    {#if !i }
    <input type="hidden" name="sku" value="{sku}"/>
    <input type="hidden" name="cartid" value="{cartid}"/>
    {/if}
    <OneAudio bind:af={af} number={i} bind:allAFs={audiofiles}/>
    {/each}

    <div  class="replicator button-group">
        <input disabled={!lastvalid} type="button" name="addmoreaudio"  value="Add More Audio ⟲" class="btn btn-secondary"   on:click={handleAddMore} >
        <input disabled={!firstvalid} type="submit" name="submit" value="Review & Pay →" class="btn btn-default orange" formnovalidate="true">
    </div>
</form>
